import React, { useEffect, useRef, useState } from 'react';
import { Eye, Target } from 'lucide-react';
import './Vision.css';

const Vision = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth - 0.5) * 20,
        y: (e.clientY / window.innerHeight - 0.5) * 20
      });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const Particle = ({ delay, duration, size }) => (
    <div
      className="particle"
      style={{
        width: size,
        height: size,
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`,
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`
      }}
    />
  );

  return (
    <div ref={sectionRef} className="vision-section">

      <div className="radial-overlay" />

      <div className="vision-content">
        <div className={`vision-heading ${isVisible ? 'visible' : ''}`}>
          <h1>Our Vision & Mission</h1>
          <div className="heading-underline" />
        </div>

        <div className="cards-container">
          {/* Vision Card */}
          <div className={`card vision-card ${isVisible ? 'visible' : ''}`} style={{ transitionDelay: '0.3s' }}>
            <div className="glow-border" />
            <div className="icon-wrapper" style={{
              transform: `translate(${mousePosition.x * 0.5}px, ${mousePosition.y * 0.5}px)`
            }}>
              <div className="icon-bg">
                <Eye size={64} strokeWidth={1} className="icon-eye" />
              </div>
              <div className="orbit orbit-1" />
              <div className="orbit orbit-2" />
            </div>
            <h2>Our Vision</h2>
            <p>
              To transform the digital landscape by crafting innovative experiences that connect, inspire, and empower brands to leave a lasting impact.
            </p>
            <div className="decorative-circle vision-circle" />
          </div>

          {/* Mission Card */}
          <div className={`card mission-card ${isVisible ? 'visible' : ''}`} style={{ transitionDelay: '0.5s' }}>
            <div className="glow-border mission-glow" />
            <div className="icon-wrapper" style={{
              transform: `translate(${mousePosition.x * -0.5}px, ${mousePosition.y * -0.5}px)`
            }}>
              <div className="icon-bg mission-bg">
                <Target size={64} strokeWidth={1} className="icon-target" />
              </div>
              <div className="orbit orbit-1 mission-orbit-1" />
              <div className="orbit orbit-2 mission-orbit-2" />
            </div>
            <h2>Our Mission</h2>
            <p>
              Our mission is to deliver cutting-edge marketing solutions and creative designs that drive measurable growth, foster meaningful connections, and elevate our clients’ digital presence with excellence and originality.
            </p>
            <div className="decorative-circle mission-circle" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vision;
